module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transferWrap clearfix"
  }, _vm._l((_vm.transferLinks), function(item) {
    return _c('a', {
      key: item.href,
      class: item.className.a,
      attrs: {
        "href": item.href
      }
    }, [_c('p', {
      class: item.className.p
    }, [_c('span', {
      class: item.className.s
    }, [_c('img', {
      attrs: {
        "src": item.iconSrc,
        "alt": item.iconAlt
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.text))])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90dea20e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/transferEntrance.vue
// module id = 582
// module chunks = 5 6